function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "ic_cloud_central");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Products_icons",
  transform: "translate(-1200.000000, -1795.000000)",
  stroke: "#1CA6FF"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_cloud_central",
  transform: "translate(1205.000000, 1800.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "logo_saas_backup-copy",
  strokeWidth: 9.23863451
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-8",
  cx: 108,
  cy: 108,
  r: 108
})), /*#__PURE__*/React.createElement("path", {
  d: "M51,107.936884 C51,89.8856016 63.1117196,76 81.0920044,76 C92.0799562,76 98.5728368,80.5443787 103.192771,86.6035503 L96.9496166,92.4102564 C92.9539978,86.8560158 87.8346112,84.4575937 81.5914567,84.4575937 C68.7305586,84.4575937 60.7393209,94.4299803 60.7393209,107.936884 C60.7393209,121.443787 68.7305586,131.542406 81.5914567,131.542406 C87.8346112,131.542406 92.9539978,129.017751 96.9496166,123.589744 L103.192771,129.39645 C98.5728368,135.455621 92.0799562,140 81.0920044,140 C63.1117196,140 51,126.114398 51,107.936884 Z M112.807229,107.936884 C112.807229,89.8856016 124.918949,76 142.899233,76 C153.887185,76 160.380066,80.5443787 165,86.6035503 L158.756846,92.4102564 C154.761227,86.8560158 149.64184,84.4575937 143.398686,84.4575937 C130.537788,84.4575937 122.54655,94.4299803 122.54655,107.936884 C122.54655,121.443787 130.537788,131.542406 143.398686,131.542406 C149.64184,131.542406 154.761227,129.017751 158.756846,123.589744 L165,129.39645 C160.380066,135.455621 153.887185,140 142.899233,140 C124.918949,140 112.807229,126.114398 112.807229,107.936884 Z",
  id: "cc",
  strokeWidth: 1.1,
  fill: "#1CA6FF",
  fillRule: "nonzero"
}))));

const SvgIcCloudCentral = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 226 226",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCloudCentral, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-cloud-central.87d24baa.svg";
export { ForwardRef as ReactComponent };